export default __webpack_public_path__ + "static/media/Summer-Dance-Camp-2026.9206be96.png";